import { render, staticRenderFns } from "./UsersAdd.vue?vue&type=template&id=fa875490"
import script from "./UsersAdd.vue?vue&type=script&lang=ts"
export * from "./UsersAdd.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports